export const constants = {
  RESET: "RESET",
  CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
  HIDE_LOADER: "HIDE_LOADER",
  USER_CHECK_LOGIN: "USER_CHECK_LOGIN",
  SET_PERSON_DATA: "SET_PERSON_DATA",
  SET_PRACTITIONER_DATA: "SET_PRACTITIONER_DATA",
  SET_ORGANISATION_DATA: "SET_ORGANISATION_DATA",
  USER_LOGOUT: "USER_LOGOUT",
  USER_DATA: "USER_DATA",
  RELATED_PERSONS_DATA: "RELATED_PERSONS_DATA",
  ACTIVE_PERSON_ID: "ACTIVE_PERSON_ID",
  SET_CURRENT_USER_SETTINGS: "SET_CURRENT_USER_SETTINGS",
  SET_VOICE_EDIT_SETTINGS: "SET_VOICE_EDIT_SETTIGNS",
  SET_CURRENT_USER_PRACTICE_DATA: "SET_CURRENT_USER_PRACTICE_DATA",
  SET_CURRENT_USER_CONFIGURATION: "SET_CURRENT_USER_CONFIGURATION",
  SET_DASHBOARD_LOADED: "SET_DASHBOARD_LOADED",
  SET_IS_DIRTY: "SET_IS_DIRTY",
  SET_SHOW_BACKDROP: "SET_SHOW_BACKDROP",
  SHOW_LOADER: "SHOW_LOADER",
  HIDE_LOADER: "HIDE_LOADER",
  SET_SEARCH_KEYWORD: "SET_SEARCH_KEYWORD",
  SET_USER_TEMPLATE_PREFERENCES: "SET_USER_TEMPLATE_PREFERENCES",
  RESET_CONVERSATION: "RESET_CONVERSATION",
  RECORDING_STATUS: "RECORDING_STATUS",
  RECORDING_STOPPED: "RECORDING_STOPPED",
  RECORDING_PAUSED: "RECORDING_PAUSED",
  RECODING_DRAFT: "RECORDING_DRAFT",
  SET_TEMP_DATA: "SET_TEMP_DATA",
  SET_TEMP_DATA_RESET: "SET_TEMP_DATA_RESET",
  APPEND_TEMP_DATA: "APPEND_TEMP_DATA",
  NEW_VISIT_SELECTED: "NEW_VISIT_SELECTED",
  AUDIO_LANGUAGE: "AUDIO_LANGUAGE",
  PRINT_WATERMARK: "PRINT_WATERMARK",
  SET_CONVERSATIONAL_LANGAUGE: "SET_CONVERSATIONAL_LANGAUGE",
  PROGRESS_STATUS: "PROGRESS_STATUS",
  APP: {
    TOGGLE_LOADER: "TOGGLE_LOADER",
    UPDATE_ROUTES: "UPDATE_ROUTES",
    CHANGE_THEME: "CHANGE_THEME",
    FIRST_RENDER_UPDATE: "FIRST_RENDER_UPDATE",
    STORE_NOTIFICATIONS: "STORE_NOTIFICATIONS",
    CHANGE_ACTIVE_TAB: "CHANGE_ACTIVE_TAB",
    SIDEBAR_ACTIVE: "SIDEBAR_ACTIVE",
    OPEN_ALERT: "OPEN_ALERT",
    CLOSE_ALERT: "CLOSE_ALERT",
    SHOW_EDIT_DATA: "SHOW_EDIT_DATA",
    OFFLINE_FALLBACK: "OFFLINE_FALLBACK",
    FULL_PAGE_LOADER: "FULL_PAGE_LOADER",
    GENERATE_NOTIFICATIONS: "GENERATE_NOTIFICATIONS",
    CLEAR_NOTIFICATIONS: "CLEAR_NOTIFICATIONS",
    DELETE_NOTIFICATIONS: "DELETE_NOTIFICATIONS",
    READ_NOTIFICATIONS: "READ_NOTIFICATIONS",
    EDIT_WIDGET: "EDIT_WIDGET",
    SET_DASHBOARD_SELECTED_WIDGETS: "SET_DASHBOARD_SELECTED_WIDGETS",
    SAVE_SESSION_CONTEXT: "SAVE_SESSION_CONTEXT",
    SAVE_AGENT_CONTEXT: "SAVE_AGENT_CONTEXT",
    SET_TOPBAR_CONTENT: "SET_TOPBAR_CONTENT",
    CLEAR_TOPBAR_CONTENT: "CLEAR_TOPBAR_CONTENT",
  },
  TAB: {
    UPDATE_TAB_VALUE: "UPDATE_TAB_VALUE",
    UPDATE_SUBTAB_VALUE: "UPDATE_SUBTAB_VALUE",
  },
  APPOINTMENTS: {
    UPDATE_SELECTED_LOCATIONS: "UPDATE_SELECTED_LOCATIONS",
    UPDATE_SELECTED_DOCTORS: "UPDATE_SELECTED_DOCTORS",
  },
  TASKS: {
    TASK_DETAILS: "TASK_DETAILS",
  },
  SURVEY: {
    SET_SURVEY_USER: "SET_SURVEY_USER",
  },
  CLINICAL_TRIALS: {
    SET_CLINICAL_TRIAL_USER: "SET_CLINICAL_TRIAL_USER",
  },
  PATIENTS: {
    PATIENT_OBJECT: "PATIENT_OBJECT",
  },
  ENCOUNTER: {
    ENCOUNTER_OBJECT: "ENCOUNTER_OBJECT",
    VISIT_OBJECT: "SCRIBE_OBJECT",
    ADD_VISIT: "ADD_VISIT",
    TOGGLE_SELECT: "TOGGLE_SELECT",
    ENCOUNTER_RESOURCE: "ENCOUNTER_RESOURCE",
  },
  SCRIBE: {
    SELECTED_TAB: "SELECTED_TAB",
    SHOW_POPUP: "SHOW_POPUP",
    SELECTED_TEMPLATE: "SELECTED_TEMPLATE",
    CDSS_REGEN_OBJ: "CDSS_REGEN_OBJ",
    AUTO_START: "AUTO_START",
    SET_SUBSCRIPTION_POPUP: "SET_SUBSCRIPTION_POPUP",
    SET_EXCEEDED_SUBSCRIPTION_POPUP: "SET_EXCEEDED_SUBSCRIPTION_POPUP",
    SET_MOBILE_COLLAPSE: "SET_MOBILE_COLLAPSE",
    SET_PERSIST_ENC_ID: "SET_PERSIST_ENC_ID",
  },
  CDSS: {
    SET_ADD_SUFFIX: "SET_ADD_SUFFIX",
  },
  QUICK_ACCESS: {
    ADMIN_DASHBOARD: {
      SET_IS_VISIBLE: "ADMIN_DASHBOARD/SET_IS_VISIBLE",
      SET_IS_DISABLED: "ADMIN_DASHBOARD/SET_IS_DISABLED",
    },
    PATIENT_DASHBOARD: {
      SET_IS_VISIBLE: "PATIENT_DASHBOARD/SET_IS_VISIBLE",
      SET_IS_DISABLED: "PATIENT_DASHBOARD/SET_IS_DISABLED",
    },
    RESET: "RESET",
    CLOSE_OVERLAY: "CLOSE_OVERLAY",
  },
  SUBSCRIPTION: {
    SET_CURRENT_SUBSCRIPTION: "SET_CURRENT_SUBSCRIPTION",
    SET_AVAILABLE_PLANS: "SET_AVAILABLE_PLANS",
    RESET_SUBSCRIPTION: "RESET_SUBSCRIPTION",
  },
  LICENSE: {
    PACKAGE: "PACKAGE",
    PLAN_STATUS: "PLAN_STATUS",
  },
  AGENT_SELECTION: {
    SET_SELECTED_AGENT: "SET_SELECTED_AGENT",
    RESET_SELECTED_AGENT: "RESET_SELECTED_AGENT",
  },
  CHAT: {
    TOGGLE_PERSIST_CHAT: "TOGGLE_PERSIST_CHAT",
    SET_SELECTED_CONVERSATION: "SET_SELECTED_CONVERSATION",
  },
  LOCATION: {
    SET_AVAILABLE_LOCATIONS: "SET_AVAILABLE_LOCATIONS",
    SET_SELECTED_LOCATION: "SET_SELECTED_LOCATION",
  },
};
